// ReSharper disable InconsistentNaming
export const RESEND_RECEIPT_ACTION = "RESEND_RECEIPT_ACTION";
export const RETRIEVE_RECEIPT_DATA_ACTION = "RETRIEVE_RECEIPT_DATA_ACTION";
export const RETRIEVE_RECEIPT_DATA_SUCCESS_ACTION = "RETRIEVE_RECEIPT_DATA_SUCCESS_ACTION";
export const SHOW_SPINNER = "SHOW_SPINNER";
export const ERROR = "ERROR";
// ReSharper restore InconsistentNaming
